import React, { FunctionComponent } from 'react';

import { PaymentMethodStep as CommonPaymentMethod } from 'scenes/common/components/Steps';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import {
  getPaymentMethodOptions,
  getPaymentMethod,
  getContactEmailAddress,
  getPolicyStartDate,
} from 'scenes/landlord/selectors';
import { FunnelType } from 'scenes/common/types';

const PaymentMethodStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onBpayPayment,
  onNext,
}) => (
  <CommonPaymentMethod
    defaultStateValue={getPaymentMethod(funnelState)}
    paymentMethodOptions={getPaymentMethodOptions(funnelState)}
    onNext={onNext}
    onBpayPayment={onBpayPayment}
    emailAddress={getContactEmailAddress(funnelState)}
    policyStartDate={getPolicyStartDate(funnelState)}
    productType={FunnelType.Landlord}
  />
);

export default PaymentMethodStep;
